import { render, staticRenderFns } from "./TabelaCotacaoPedido.vue?vue&type=template&id=131a38e2&scoped=true"
import script from "./TabelaCotacaoPedido.vue?vue&type=script&lang=js"
export * from "./TabelaCotacaoPedido.vue?vue&type=script&lang=js"
import style0 from "./TabelaCotacaoPedido.vue?vue&type=style&index=0&id=131a38e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131a38e2",
  null
  
)

export default component.exports